import clone from 'lodash.clonedeep'
import get from 'lodash.get'
import { IApiConfig } from '../@types/config'
import { AppEvent } from '../constants/events'
import { logger } from './logger'
import { Device } from './device'

export class Tracker {
  static id: string = process.env.NEWRELIC_APP_ID || ''

  static record(
    event: AppEvent,
    apiConfig: IApiConfig,
    extraData: {} = {}
  ): void {
    try {
      const newrelicID = get(window, '$mediavine.newrelic.info.applicationID')

      if (newrelicID !== Tracker.id) {
        logger.log('METRICS:', '(skipping)', event)
        return
      }

      const send = get(window, '$mediavine.newrelic.addPageAction')
      const versionGroup = get(window, '$mediavine.web.model.versionGroup')
      const s2sVersion = get(window, '$mediavine.web.s2sBetaSelection')
      const config = clone(apiConfig) // newrelic is impure
      const data = {
        deviceType: Device.type,
        domain: window.location.hostname.replace('www.', ''),
        generator: 'video',
        group: config.playerGroup,
        slug: config.slug,
        version: config.playerVersion,
        wrapperGroup: versionGroup.name,
        wrapperVersion: versionGroup.version,
        s2sVersion: s2sVersion.name,
        ...extraData
      }

      send(event, data)
      logger.log('METRICS:', event)
    } catch (err) {
      logger.error('NewRelic.addPageAction error:', err)
    }
  }
}
